const reverseBirthDate = (birthDate: string) => {
  return birthDate?.split('.').reverse().join('-');
};

export default reverseBirthDate;
